import React from 'react';

export const SupportPage: React.FC = () => {
  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '2rem 1rem', fontFamily: 'system-ui, sans-serif' }}>
      <h1>RepsLearn Support</h1>

      <section style={{ marginBottom: '2rem' }}>
        <h2>Contact Us</h2>
        <p>
          If you need help or have questions about RepsLearn, please reach out to us at:
        </p>
        <p>
          <a href="mailto:support@repslearn.com">support@repslearn.com</a>
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2>Frequently Asked Questions</h2>

        <h3>How do I create an account?</h3>
        <p>
          Tap "Sign Up" on the login screen. You can register with your email, Google account, or Apple ID.
          Students select their grade level during registration.
        </p>

        <h3>How do I delete my account?</h3>
        <p>
          Go to Settings and scroll to the "Danger Zone" section. Tap "Delete Account" and follow the confirmation
          steps. This permanently removes your account and all associated data.
        </p>

        <h3>How does parent linking work?</h3>
        <p>
          Parents can link to their child's account by entering the child's email on the Parent Dashboard.
          The student will receive a link request that they can accept or decline.
        </p>

        <h3>I forgot my password</h3>
        <p>
          On the login screen, tap "Forgot Password?" and enter your email address. You'll receive
          a password reset link. If you signed in with Google or Apple, use those sign-in options instead.
        </p>

        <h3>How do I switch between grade levels?</h3>
        <p>
          Use the curriculum selector dropdown on the Dashboard to switch between your enrolled
          grade levels. You can add new grades from the Settings page.
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2>Privacy</h2>
        <p>
          We take your privacy seriously. RepsLearn collects only the data necessary to provide
          personalized math practice. For any privacy-related questions, please contact us at{' '}
          <a href="mailto:support@repslearn.com">support@repslearn.com</a>.
        </p>
      </section>
    </div>
  );
};
